import Alpine from "alpinejs";
import { MDCSlider } from "@material/slider/index";

// To load our fonts
window.WebFont = require("webfontloader");

document.addEventListener("alpine:init", () => {
  Alpine.data("pricingController", () => ({
    currentPoint: 1,
    priceInterval: "month",
    pricePoints: [
      { pageviews: "up to 10,000", price: { month: "$6", year: "$60" } },
      { pageviews: "up to 30,000", price: { month: "$15", year: "$150" } },
      { pageviews: "up to 100,000", price: { month: "$30", year: "$300" } },
      { pageviews: "up to 300,000", price: { month: "$75", year: "$750" } },
      {
        pageviews: "up to 1,000,000",
        price: { month: "$200", year: "$2,000" },
      },
      {
        pageviews: "1,000,000+",
        price: { month: "Contact Us", year: "Contact Us" },
        hidePerMonth: "true",
      },
    ],

    init() {
      const slider = new MDCSlider(document.querySelector(".mdc-slider"));
      this.currentPoint = slider.getValue();

      slider.root.addEventListener(
        "MDCSlider:change",
        function() {
          this.currentPoint = slider.getValue();
        }.bind(this),
      );
    },
  }));
});

Alpine.start();
